/**
 * Org-level AI feature settings, stored in `organizations.ai_feature_settings`.
 */
export type AiFeatureSettings = {
  agents?: boolean;
  warehouseToolsInBackground?: boolean;
};

export type ResolvedAiFeatureSettings = Required<AiFeatureSettings>;

/**
 * Resolves stored org AI feature settings to concrete booleans.
 *
 * Absence means enabled: a missing key (or an org that has never saved
 * settings) is treated as on, so shipping the column disables nothing for
 * existing orgs and any future-added feature defaults to enabled.
 */
export const resolveAiFeatureSettings = (
  settings: AiFeatureSettings | null | undefined,
): ResolvedAiFeatureSettings => ({
  agents: settings?.agents ?? true,
  warehouseToolsInBackground: settings?.warehouseToolsInBackground ?? true,
});
